(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pyrella-books-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('.pb-pdp').forEach(function (section) {
        if (section.dataset.pbReady) return;
        section.dataset.pbReady = 'true';
        var tabs = section.querySelectorAll('[data-pb-panel]');
        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t === tab)); });
            section.querySelectorAll('[data-pb-view]').forEach(function (panel) {
              panel.hidden = panel.dataset.pbView !== tab.dataset.pbPanel;
            });
          });
        });
        var sticky = section.querySelector('[data-pb-sticky]');
        var main = section.querySelector('[data-pb-main-cta]');
        var finalBlock = section.querySelector('[data-pb-final]');
        if (sticky && main && 'IntersectionObserver' in window) {
          var mainVisible = true, finalVisible = false;
          var update = function () {
            var show = !mainVisible && !finalVisible;
            sticky.classList.toggle('is-visible', show);
            sticky.setAttribute('aria-hidden', String(!show));
            var btn = sticky.querySelector('button');
            if (btn) btn.tabIndex = show ? 0 : -1;
          };
          new IntersectionObserver(function (e) { mainVisible = e[0].isIntersecting || e[0].boundingClientRect.top > 0; update(); }).observe(main);
          if (finalBlock) new IntersectionObserver(function (e) { finalVisible = e[0].isIntersecting; update(); }).observe(finalBlock);
        }
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
